import { type FC } from "react";
import { Table } from "@root/shared/components/Table/legacy/Table";
import { MultiLineText } from "@root/shared/components/MultiLineText";
import { LazyLoadImage } from "@root/shared/components/LazyLoadImage";
import { DetailTableRow } from "@clientFrontend/features/publication/components/DetailTableRow";
import * as styles from "./styles.css";

type Image = {
  id: number | null;
  src: string | null;
};

type BrandContent = {
  name: string;
  logoImage: Image;
  clientImage: Image;
  concept: string;
};

type Props = {
  brandContent: BrandContent;
  site: "biyo" | "kaigo";
};

export const BrandContentDetail: FC<Props> = ({ brandContent, site }) => {
  return (
    <section>
      <h2 className={styles.sectionTitle[site]}>ブランド情報</h2>
      <Table>
        <DetailTableRow header="ブランド名">{brandContent.name}</DetailTableRow>
        <DetailTableRow header="ブランドロゴ画像">
          {brandContent.logoImage.src && (
            <figure className={styles.imageContainer}>
              <LazyLoadImage
                src={brandContent.logoImage.src}
                alt="ブランドロゴ画像"
                width={280}
                height={158}
              />
            </figure>
          )}
        </DetailTableRow>
        <DetailTableRow header="ブランドイメージ画像">
          {brandContent.clientImage.src && (
            <figure className={styles.imageContainer}>
              <LazyLoadImage
                src={brandContent.clientImage.src}
                alt="ブランドイメージ画像"
                width={280}
                height={158}
              />
            </figure>
          )}
        </DetailTableRow>
        <DetailTableRow header="ブランドコンセプト">
          {brandContent.concept && <MultiLineText text={brandContent.concept} />}
        </DetailTableRow>
      </Table>
    </section>
  );
};
